module.exports = __webpack_public_path__ + "media/images/svg/arrow-b91bb345edfea403c5f71a8768bdd9fe.svg";